import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import { CartProvider } from "./context/CartContext"; // ✅ استيراد الكونتكست

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <CartProvider>
    {" "}
    {/* ✅ لفّ كل المشروع داخل CartProvider */}
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </CartProvider>
);
